import React from "react";
import CartReducer from "./cartReducer";
import actions from "./cartActions";

export const cartContext = React.createContext();

const CartProvider = ({ children }) => {
  const { Provider } = cartContext;

  const initialState = {
    cartItems: [],
    totalQuantity: 0,
    totalAmount: 0,
    currencies: [],
    selectedCurrency: "",
    locationDetails: {
      duration: "",
      location: ""
    },
    deliveryType: "pickup",
    deliveryAmount: 0
  };

  const init = payload => {
    dispatch({ type: actions.INIT, payload });
  };

  const [state, dispatch] = React.useReducer(CartReducer, initialState);

  return <Provider value={{ state, init, dispatch }}>{children}</Provider>;
};

export default CartProvider;

// custom hook for accessing user data
export const useCart = () => {
  const context = React.useContext(cartContext);

  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }

  return context;
};
